import { render, staticRenderFns } from "./PaginationBack.vue?vue&type=template&id=83362178"
import script from "./PaginationBack.vue?vue&type=script&lang=js"
export * from "./PaginationBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports